import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '@/config/api';

const SiteSettingsContext = createContext(null);

const DEFAULT_NAV = [
  { path: '/', label: '首頁' },
  { path: '/about', label: '關於我們' },
  { path: '/courses', label: '課程資訊' },
  { path: '/instructors', label: '導師介紹' },
  { path: '/blog', label: '考試資料' },
  { path: '/exam-guide', label: '考試攻略' },
  { path: '/contact', label: '聯絡我們' },
];

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [navItems, setNavItems] = useState(DEFAULT_NAV);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/settings`);
        setSettings(res.data);
        try {
          const items = JSON.parse(res.data.navbar_items || '[]');
          if (items.length > 0) setNavItems(items);
        } catch {}
      } catch (error) {
        console.error('Failed to fetch site settings:', error);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (!settings) return;
    if (settings.seo_title) document.title = settings.seo_title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && settings.seo_description) metaDesc.setAttribute('content', settings.seo_description);
    if (settings.favicon_url) {
      let link = document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = settings.favicon_url;
    }
  }, [settings]);

  return (
    <SiteSettingsContext.Provider value={{
      settings,
      navItems,
      trackingIds: {
        googleAnalyticsId: settings?.google_analytics_id || '',
        metaPixelId: settings?.meta_pixel_id || '',
      },
    }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

const DEFAULT_TRACKING_IDS = { googleAnalyticsId: '', metaPixelId: '' };

export const useSiteSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  return ctx || { settings: null, navItems: DEFAULT_NAV, trackingIds: DEFAULT_TRACKING_IDS };
};
